<div class="icon-overflow">
  <div
    *ngFor="let icon of icons"
    class="icon-alignment"
    [ngbTooltip]="tipContent"
    container="body"
    tooltipClass="icon-grid-tooltip"
    data-bs-placement="top"
  >
    <svg
      viewBox="0 0 24 24"
      width="25"
      height="25"
      class="icon"
      [ngStyle]="{ color: getIconColor(icon.id) }"
    >
      <path [attr.d]="icon.path" fill="currentColor" />
    </svg>
    <ng-template #tipContent>
      <div class="row">
        <div class="col">
          <span style="font-weight: bold" [innerHTML]="getTooltipText(icon.id)"></span>
        </div>
      </div>
    </ng-template>
  </div>
  <div class="d-flex">
    <a id="seeDetails" class="emailStatus verificationLink" (click)="seeDetails()">See details</a>
  </div>
</div>
